import { combineReducers } from 'redux';

import createReducer from '../../utils/createReducer';
import {
  EXPERIENCES_FETCH_FAILURE,
  EXPERIENCES_FETCH_SUCCESS,
  EXPERIENCE_COMPLETE_SUCCESS,
} from './types';

const experiences = createReducer(
  {},
  {
    [EXPERIENCES_FETCH_SUCCESS]: (draft, { payload }) => {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'experiences' does not exist on type 'und... Remove this comment to see the full error message
      for (const experience of payload.experiences) {
        draft[experience.name] = experience;
      }
    },

    [EXPERIENCE_COMPLETE_SUCCESS]: (draft, { payload }) => {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'experience' does not exist on type 'unde... Remove this comment to see the full error message
      const { experience } = payload;
      draft[experience.name] = experience;
    },
  }
);

const isReady = createReducer(false, {
  [EXPERIENCES_FETCH_FAILURE]: () => false,
  [EXPERIENCES_FETCH_SUCCESS]: () => true,
});

export default combineReducers({
  experiences,
  isReady,
});
